"use strict";

exports.__esModule = true;
exports.SectionLabelElement = void 0;
var _uiSwitch = require("../../Theme/UiDesign/uiSwitch");
var _SectionLabelElement = require("./SectionLabelElement.legacy");
var _SectionLabelElement2 = require("./SectionLabelElement.modern");
// Flag-gated UI: `SectionLabelElement.legacy` is the component as it is on
// master, `SectionLabelElement.modern` the compact note. The nearest
// UiDesignProvider decides which renders.
var SectionLabelElement = exports.SectionLabelElement = (0, _uiSwitch.uiSwitch)(_SectionLabelElement.SectionLabelElement, _SectionLabelElement2.SectionLabelElement, "SectionLabelElement");